var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "ugc-terms-conditions-new-modal-text",
    attrs: {
      "id": "dialog-desc"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.translations.termsConditionTopMessage))]), _c('ul', {
    staticClass: "ugc-terms-list check"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.termsConditionText1,
      expression: "!!translations.termsConditionText1"
    }]
  }, [_c('span', {
    staticClass: "icon-success"
  }), _vm._v("\n      " + _vm._s(_vm.translations.termsConditionText1) + "\n    ")]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.termsConditionText2,
      expression: "!!translations.termsConditionText2"
    }]
  }, [_c('span', {
    staticClass: "icon-success"
  }), _vm._v("\n      " + _vm._s(_vm.translations.termsConditionText2) + "\n    ")]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.termsConditionText3,
      expression: "!!translations.termsConditionText3"
    }]
  }, [_c('span', {
    staticClass: "icon-success"
  }), _vm._v("\n      " + _vm._s(_vm.translations.termsConditionText3) + "\n    ")]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.termsConditionText4,
      expression: "!!translations.termsConditionText4"
    }]
  }, [_c('span', {
    staticClass: "icon-success"
  }), _vm._v("\n      " + _vm._s(_vm.translations.termsConditionText4) + "\n    ")]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.termsConditionText5,
      expression: "!!translations.termsConditionText5"
    }]
  }, [_c('span', {
    staticClass: "icon-success"
  }), _vm._v("\n      " + _vm._s(_vm.translations.termsConditionText5) + "\n    ")])]), _c('ul', {
    staticClass: "ugc-terms-list x"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.termsConditionText6,
      expression: "!!translations.termsConditionText6"
    }]
  }, [_c('span', {
    staticClass: "icon-circle-with-plus"
  }), _c('span', [_vm._v(" " + _vm._s(_vm.translations.termsConditionText6) + " ")])]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.termsConditionText7,
      expression: "!!translations.termsConditionText7"
    }]
  }, [_c('span', {
    staticClass: "icon-circle-with-plus"
  }), _vm._v("\n     " + _vm._s(_vm.translations.termsConditionText7) + "\n    ")]), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.termsConditionText8,
      expression: "!!translations.termsConditionText8"
    }]
  }, [_c('span', {
    staticClass: "icon-circle-with-plus"
  }), _vm._v("\n      " + _vm._s(_vm.translations.termsConditionText8) + "\n    ")])]), _c('div', {
    staticClass: "ugc-terms-conditions-new-modal-text-content-rights row"
  }, [_c('div', {
    staticClass: "small-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.translations.termsConditionContentRights))]), _vm._v(" " + _vm._s(_vm.translations.termsConditionContentRights2) + "\n    ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.contactFormDesc && !!_vm.translations.contactFormDesc2,
      expression: "!!translations.contactFormDesc && !!translations.contactFormDesc2"
    }],
    staticClass: "row contact-form-legal-text"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.contactFormDesc) + "\n      "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.contactFormLinkDesc,
      expression: "!!translations.contactFormLinkDesc"
    }],
    attrs: {
      "href": _vm.translations.contactFormLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.translations.contactFormLinkDesc))]), _vm._v(_vm._s(_vm.translations.contactFormDesc2)), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !!_vm.translations.contactFormLinkDesc2,
      expression: "!!translations.contactFormLinkDesc2"
    }],
    attrs: {
      "href": _vm.translations.contactFormLink2,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.translations.contactFormLinkDesc2))])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }